import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaTiktok, FaFacebookF, FaWhatsapp } from 'react-icons/fa';
import { Mail, MapPin } from 'lucide-react';
import '../styles/footer.css';

const socials = [
  { label: 'Instagram', Icon: FaInstagram, href: 'https://www.instagram.com/godsonfoods.ca?stkn=NXZiaDl1aXZqOXd2&utm_source=qr' },
  { label: 'TikTok', Icon: FaTiktok, href: 'https://www.tiktok.com/@godsonfoods?_r=1&_t=ZS-9ALb6YonqSM' },
  { label: 'Facebook', Icon: FaFacebookF, href: 'https://www.facebook.com/share/18bZgYQh7B/?mibextid=wwXIfr' },
];
function Footer() {
  return (
    <footer id="contact" className="store-footer">
      <div className="store-shell footer-grid">
        <div>
          <Link to="/" className="footer-brand"><img src="/images/icon.png" alt="" />GODSON FOODS<span>.</span></Link>
          <p>Authentic African flavours, fresh groceries and everyday essentials. Bring home the food you love.</p>
          <div className="footer-socials">{socials.map(({ label, Icon, href }) => <a key={label} href={href} aria-label={label} target="_blank" rel="noopener noreferrer"><Icon size={20} /></a>)}</div>
        </div>
        <div><h2>Explore</h2><ul><li><Link to="/products">Shop groceries</Link></li><li><Link to="/onsale">Special offers</Link></li><li><Link to="/track">Track your order</Link></li><li><Link to="/cartpage">Your basket</Link></li></ul></div>
        <div><h2>Contact us</h2><ul className="footer-contact">
          <li><FaWhatsapp size={20} /><a href="https://wa.me/16479912413" target="_blank" rel="noopener noreferrer">+1 (647) 991 2413<span>WhatsApp only</span></a></li>
          <li><Mail size={20} /><a href="mailto:Godsonfoods.ca@gmail.com">Godsonfoods.ca@gmail.com</a></li>
          <li><MapPin size={20} /><span>Toronto, Ontario, Canada</span></li>
        </ul></div>
      </div>
      <div className="store-shell footer-bottom"><span>© 2026 Godson Foods. All rights reserved.</span><span>Good food. Rooted in culture.</span></div>
    </footer>
  );
}
export default Footer;
